export enum PageType {
  LIBRARY = 'LIBRARY',
  IFRAME = 'IFRAME',
  OFFER_COMPARISON = 'OFFER_COMPARISON',
  SHARED_LINK = 'SHARED_LINK',
}
